import classNames from 'classnames';
import { Button, FlexContainer, Txt, Icon } from 'components';
import styles from './TenantDepositDetails.module.scss';

/**
 * TenantDepositDetails
 *
 * @return {JSX.Element}
 */
const TenantDepositDetails = ({
  className,
  fullName,
  emailAddress,
  mobileNumber,
  isDone,
  action,
  actionLabel,
}) => {
  return (
    <FlexContainer
      className={classNames(
        styles.TenantDepositDetails,
        className,
        TenantDepositDetails.displayName
      )}
      gap
      alignCenter
    >
      <FlexContainer flex>
        <Txt>{fullName}</Txt>
      </FlexContainer>
      <FlexContainer gapHalf alignCenter>
        {isDone ? (
          <Icon className={styles.DoneIcon} name="checkmark" highlight />
        ) : (
          <>
            <a href={`mailto:${emailAddress}`} target="_blank" rel="noreferrer">
              <Icon name="envelope" />
            </a>
            <a href={`tel:${mobileNumber}`} target="_blank" rel="noreferrer">
              <Icon name="phone" />
            </a>
            <Button warn onClick={action}>
              {actionLabel}
            </Button>
          </>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

TenantDepositDetails.displayName = 'TenantDepositDetails';

export default TenantDepositDetails;
